import { useEffect, useState } from "react";
import TabelaRanking from "../../tabelas/TabelaRanking";
import "./Ranking.css";
import {
  pegarListaRanking,
} from "../../services/api";

export default function Ranking() {

  const colunaClassificacoes = ["Posição", "Nome", "Pontos"];
  const [ranking, setRanking] = useState([]);
  const [aviso, setAviso] = useState("");

  useEffect(() => {
    carregarPg();
  }, []);

  async function carregarPg() {
    try {
      const dados = await pegarListaRanking();
      setRanking(dados);
      setAviso("Ainda não há alunos cadastrados no ranking.");
    } catch (error) {
      setAviso(
        "Não foi possível carregar o ranking. Tente novamente mais tarde."
      );
    }
  }

  return (
    <>
      <div className="container_classificacao">
        <div className="caixa_classificacao">
          <h1>Ranking</h1>
          <h2>Pontuação dos estudantes da sua escola</h2>
        </div>
        <div className="caixa_tabela">
          <TabelaRanking
            colunas={colunaClassificacoes}
            dados={ranking}
            aviso={aviso}
          />
        </div>
      </div>
    </>
  );
}
